import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            title_employee_active: "Expediente del empleado",
            cuil: "RFC",
            cuils: "RFC",
            numero_legajo: "Nro de expediente",
            title_license: "Configuración de Ausentismos",
            module_license: "Usa módulo de Vacaciones / ausentismo",
            numero_legajo_aprobador: "Número de expediente del aprobador",
        },
        label: {
            dni: "RFC",
        },
        head_text_table_search_3: "RFC",
        head_text_table_search_4: "Expediente",
        search_text_1_1: "RFC, Nombre, Apellido o Email",
        search_text_1_2: "Expediente",
        search_text_6: "Módulo de Ausentismos",
        menu_3: "Vacaciones y Ausentismos",
        uploadImageComponent: {
            errorLogs: {
                "05105": "El Nro de expediente no es número entero válido",
                "05107": "El número de Nro de expediente de aprobador no es número entero válido",
                "05133": "El Nro de expediente es duplicado",
                "05140": "No se ha podido actualizar el número de expediente ya que es aprobador de otro empleado.",

            },
        },
        searchComponent: {
            fileNumber: 'Número de expediente'
          },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "RFC",
                    question: "¿Cuál es el RFC del colaborador?",
                    description: "Ingresa el RFC del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "RFC",
                },
                dni: "RFC"
            }
        },
        documentDetail: {
            commons: {
                cuil: "CUIL"
            }
        }
    }
})